export default function PainPoints() {
  const painPoints = [
    {
      icon: 'ri-user-search-line',
      title: 'Hiring freelancers on a case-by-case basis',
      description: 'And waiting for a miracle that never happens?'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Draining budgets',
      description: 'On Yandex and Google with no visible results?'
    },
    {
      icon: 'ri-question-line',
      title: 'Have a feeling',
      description: '"I\'m doing something wrong", but no understanding of how to fix it?'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Familiar Situation?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {painPoints.map((point, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${point.icon} text-3xl text-red-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {point.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-red-50 border-2 border-red-200 rounded-xl p-6 max-w-2xl">
            <p className="text-lg text-red-800 font-medium">
              Chaotic actions without a system only lead to loss of time and money
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
